export const cn = {
    solutionCard: {
        noTitle: '无标题',
        owner: '所有者',
        label: {
            PAPER: '论文',
            PATENT: '专利',
            WEBSITE: '网站',
            NEWS: '新闻',
            REPORT: '市场报告',
            PROJECT: '项目',
            PROJECT_SEEK: '技术问答',
            PROJECT_MIND: '技术方案探索',
            PROJECT_FMEA: '设计失效分析',
            PROJECT_PDF: 'PDF',
            PROJECT_WORD: 'Word',
            PROJECT_EXCEL: 'Excel',
            PROJECT_RD_MIND: '技术方案探索',
        },
        PAPER: {
            PBD: '出版日期',
        },
        PATENT: {
            APD: '申请日期',
            PBD: '公开日期',
            ISD: '初始开始日期',
            EXPD: '到期日期',
            PRIORITY_DATE: '优先权日期',
        },
        NEWS: {
            PBD: '发布日期',
        },
        ai_summary: 'AI 核心要点',
        cagr: '复合年均增长率',
        category: '市场类别',
        cagrValue: '{year}年 {mount}',
    },
}

export const en = {
    solutionCard: {
        noTitle: 'No Title',
        owner: 'Owner',
        label: {
            PAPER: 'Paper',
            PATENT: 'Patent',
            WEBSITE: 'Website',
            NEWS: 'News',
            REPORT: 'Market Report',
            PROJECT: 'Project',
            PROJECT_SEEK: 'Tech Q&A',
            PROJECT_MIND: 'Find solution',
            PROJECT_FMEA: 'DFMEA Assistant',
            PROJECT_PDF: 'PDF',
            PROJECT_WORD: 'Word',
            PROJECT_EXCEL: 'Excel',
            PROJECT_RD_MIND: 'Find solution',
        },
        PAPER: {
            PBD: 'Public Date',
        },
        PATENT: {
            APD: 'Application Date',
            PBD: 'Publication Date',
            ISD: 'Initial Start Date',
            EXPD: 'Expiration Date',
            PRIORITY_DATE: 'Priority Date',
        },
        NEWS: {
            PBD: 'Public Date',
        },
        ai_summary: 'AI Summary',
        cagr: 'CAGR',
        category: 'Market Category',
        cagrValue: '{mount} in {year}',
    },
}

export const jp = {
    solutionCard: {
        noTitle: 'タイトルなし',
        owner: '所有者',
        label: {
            PAPER: '論文',
            PATENT: '特許',
            WEBSITE: 'ウェブサイト',
            NEWS: 'ニュース',
            REPORT: '市場報告',
            PROJECT: 'プロジェクト',
            PROJECT_SEEK: '技術Q&A',
            PROJECT_MIND: '技術ソリューション探索',
            PROJECT_FMEA: 'DFMEAアシスタント',
            PROJECT_PDF: 'PDF',
            PROJECT_WORD: 'Word',
            PROJECT_EXCEL: 'Excel',
            PROJECT_RD_MIND: '技術ソリューション探索',
        },
        PAPER: {
            PBD: '出版日',
        },
        PATENT: {
            APD: '申請日',
            PBD: '公開日',
            ISD: '初始開始日',
            EXPD: '有効期限',
            PRIORITY_DATE: '優先權日',
        },
        NEWS: {
            PBD: '発表日',
        },
        ai_summary: 'AI 要約',
        cagr: 'CAGR',
        category: '市場カテゴリ',
        cagrValue: '{year}年 {mount}',
    },
}

export const tw = {
    solutionCard: {
        noTitle: '無標題',
        owner: '所有者',
        label: {
            PAPER: '論文',
            PATENT: '專利',
            WEBSITE: '網站',
            NEWS: '新聞',
            REPORT: '市場報告',
            PROJECT: '專案',
            PROJECT_SEEK: '技術問答',
            PROJECT_MIND: '技術方案探索',
            PROJECT_FMEA: '設計失效分析',
            PROJECT_PDF: 'PDF',
            PROJECT_WORD: 'Word',
            PROJECT_EXCEL: 'Excel',
            PROJECT_RD_MIND: '技術方案探索',
        },
        APD: '申請日期',
        PAPER: {
            PBD: '出版日期',
        },
        PATENT: {
            APD: '申請日期',
            PBD: '公開日期',
            ISD: '初始開始日期',
            EXPD: '到期日期',
            PRIORITY_DATE: '優先權日期',
        },
        NEWS: {
            PBD: '發佈日期',
        },
        ai_summary: 'AI 核心要點',
        cagr: '複合年均增長率',
        category: '市場類別',
        cagrValue: '{year}年 {mount}',
    },
}
